// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__hey4R","down":"Counter_down__mU1AK","up":"Counter_up__ajuMK","count":"Counter_count__hPS7g"};